import React, { useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box, Typography, Button
} from "@mui/material";
import { styled } from "@mui/system"
import PropTypes from 'prop-types'
import lottie from "lottie-web";
import * as config from "../../../next.config.js"
import LoadingButton from '@mui/lab/LoadingButton'

import { useTranslation } from 'next-i18next'
import {CustomeDialogContent} from "../StyledComponent/HintDialog1.style"
import {CustomeDialogActions} from "../StyledComponent/HintDialog1.style"
import {CustomeBox} from "../StyledComponent/HintDialog1.style"
import {BootstrapDialog} from "../StyledComponent/HintDialog1.style"
import {Customebtn} from "../StyledComponent/HintDialog1.style"

export default function ConfirmDialog(props) {
  const { t } = useTranslation("common")

  const lottieDiv = React.useRef()
  useEffect(() => {
    setTimeout(() => {let instance = lottie.loadAnimation({
      container: lottieDiv.current,

      loop: true,
      autoplay: true,
      renderer: "svg",
      path: config.basePath + (props.type == "success" ? `/json/success.json` : "/json/error.json"),
      rendererSettings: {

        id: "imgSuccess"


      }
    })
    instance.play()
})

  



  }, [props.open, lottieDiv])
  return (
    <>
      <BootstrapDialog
        open={props.open}
        maxWidth={"xs"}
        fullWidth
        onClose={props.onClose}
        PaperProps={{
          sx: { overflow: "visible", position: "relative" },

        }}
      >
           <CustomeBox
          ref={lottieDiv}
        //   id="errorDialogId"
          // sx={{
          //   width: "100%",

          //   left: 0,
          //   top: -190,
          //   padding: "20px 0px",

          //   position: "absolute"
          // }}
        ></CustomeBox>

        <CustomeDialogContent style={{ position: "relative", width: "100%" }}>
          <br />
          {props.title?<Typography
            style={{ textAlign: "center", fontWeight: "bold", color: "#F52A59", padding: "10px 0px" }}
            variant="h3"
          >
            {/* {t("ttlMessage")} */}
   
            {props.title}



          </Typography>:""}
          <Typography
            style={{ textAlign: "center", fontWeight: "bold", padding: "10px 0px" }}
            variant="h5"
          >
            {props.text}
      




                 </Typography>
        </CustomeDialogContent>
        <CustomeDialogActions
          justifyContent="center"
          style={{ justifyContent: "center" }}
        >
          <Customebtn
            variant={"contained"}
            color="secondary"
            // sx={{ backgroundColor: "#F52A59 !important" }}
            onClick={props.btnHome}
            // loading={props.loading}
          >
            {t("Homepage")}
           
          </Customebtn>

          <Customebtn
            variant={"contained"}
            color="secondary"
            // loading={props.loading}
            onClick={props.btnDash}
          >
               {/* {props.confirmBtnTitle} */}
            {t("dashboard")}
          </Customebtn>

        </CustomeDialogActions>
        {props.children}
      </BootstrapDialog>
    </>
  );
}
ConfirmDialog.propTypes = {
  confirm: PropTypes.func,
  reject: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  text: PropTypes.string
}